import { IS_WL_QUERY_TRUE_STRING } from '../../constants';

export const checkIsWLByUrl = (url?: string): boolean =>
  !!url && (/(^|\/)(wl|whitelable)(?=\/|$|\?|#)/.test(url) || url.includes(IS_WL_QUERY_TRUE_STRING));
